import { combineReducers } from 'redux';
import createSaga from './saga';
import { createReduceObject as createReqStatusReduceObject } from '../../../../../common/reducers/_requestStatus/reducer';
import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/_list/reducer';
import { createReduceObject as createPaginationReduceObject } from '../../../../../common/reducers/_pagination/reducer';
import { reducerRegistry } from '../../../../../reducerRegistry';

export const createReducerName = name => `tasks/${name}`;

export function registryCombineReducer(reducerName) {
  const combine = combineReducers({
    ...createReqStatusReduceObject(reducerName),
    ...createListReduceObject(reducerName),
    ...createPaginationReduceObject(reducerName)
  });
  reducerRegistry.register(reducerName, combine, createSaga);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/dynamic/tasksList/combineRegistry.js